export default {
  methods: {
    startWalkthrough(id) {
      userpilot.trigger(id);
    },
    startUserPilot(user) {
      userpilot.identify(user.id, {
        name: user.name,
        email: user.email,
        created_at: user.created_at,
        subscription: user.plan,
        roles: user.roles
      });
    }
  }
}